var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-text",on:{"click":_vm.redirect}},[_c('span',[_vm._v(_vm._s(_vm.resource.trajectory_project.name))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.resource.customer_number_according_to_client)+" - "+_vm._s([
                _vm.resource.relation.title !== 'other' ? _vm.uLang(`app.${_vm.resource.relation.title}`) : '',
                _vm.resource.relation.first_name,
                _vm.resource.relation.prefix,
                _vm.resource.relation.last_name
            ].join(' ')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }